
import { Observable } from 'rxjs';
import { ExecutionStep } from './execution-step';

export abstract class AbstractExecutionStepCondition {
    public abstract isValid(executionStep: ExecutionStep): Observable<boolean>;
}
